<template>
  <div>
    <loginbox></loginbox>
    <detailbox :title="'活动详情'" :info="info.assess_info"></detailbox>
    <infolist :title="'出售账号'" :type="2" :qq="info.qq_assess" :qqShow="info.display_qq_assess" :wechat="info.service_assess" :wechatShow="info.display_weixin_assess"></infolist>
    <detailbox :title="'活动细则'" :info="info.assess_rule"></detailbox>
    <div class="bar"></div>
  </div>
</template>

<script>
  import loginbox from '@/components/common/loginbox/loginbox'
  import detailbox from '@/components/common/detailbox/detailbox'
  import infolist from '@/components/common/infolist/infolist'
  import { configResource } from '@/resource/resource'
  import {mapState, mapMutations} from 'vuex'
  const ERR_OK = 0
  export default {
    name: 'evaluatepage',
    data () {
      return {
        info: ''
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
      this.scroll()
      if (!this.config_info.evInfo) {
        this.getConfig()
      } else {
        this.info = this.config_info.evInfo
      }
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      },
      getConfig () {
        configResource.config({ config: 'assess_info,assess_rule,qq_assess,display_qq_assess,display_weixin_assess,service_assess' }).then(response => {
          response = response.body
            if (response.errcode === ERR_OK) {
              this.config_info.evInfo = response.data
              this.info = response.data
            }
        })
      },
        // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO'
      ])
    },
    components: {
      loginbox,
      detailbox,
      infolist
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .bar
    height 0.2rem
    width 100%
</style>



// WEBPACK FOOTER //
// src/components/evaluatepage/evaluatepage.vue